const _excluded = ["checked", "partiallyChecked", "disabled", "id", "className", "onChange", "children", "error", "name", "value", "inline", "tooltip"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { CheckedIcon } from "./CheckedIcon";
import { PartiallyCheckedIcon } from "./PartiallyCheckedIcon";
import styles from "./Checkbox.module.scss";
import { Tooltip } from "../Tooltip";
export const Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
  const {
    checked,
    partiallyChecked,
    disabled,
    id,
    className,
    onChange: _onChange,
    children,
    error,
    name,
    value,
    inline,
    tooltip
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const [isChecked, setIsChecked] = useState(checked || false);
  const isControlled = typeof checked !== 'undefined'; // Makes sure the internal state reflects the provided checked prop.

  useEffect(() => {
    if (typeof checked !== 'undefined') {
      setIsChecked(checked);
    }
  }, [checked]);
  const checkbox = /*#__PURE__*/React.createElement("label", _extends({}, rest, {
    className: cn(styles.root, {
      [styles.disabled]: disabled,
      [styles.inline]: inline
    }, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.checkbox
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    className: styles.input,
    ref: ref,
    type: "checkbox",
    disabled: disabled,
    checked: isChecked,
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-input"),
    onChange: e => {
      if (!isControlled) {
        setIsChecked(e.currentTarget.checked);
      }

      _onChange && _onChange(e);
    },
    "aria-invalid": error,
    name: name,
    value: value,
    "data-state": partiallyChecked ? 'partially-checked' : isChecked ? 'checked' : 'unchecked'
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-icon"),
    className: cn(styles.checkboxIndicator, {
      [styles.checked]: isChecked && !partiallyChecked,
      [styles.unchecked]: !isChecked && !partiallyChecked,
      [styles.partiallyChecked]: partiallyChecked,
      [styles.error]: error
    })
  }, isChecked && !partiallyChecked && /*#__PURE__*/React.createElement(CheckedIcon, null), partiallyChecked && /*#__PURE__*/React.createElement(PartiallyCheckedIcon, null))), children ? children : null);
  return tooltip ? /*#__PURE__*/React.createElement(Tooltip, tooltip, /*#__PURE__*/React.createElement("div", null, checkbox)) : checkbox;
});